/* Mobil PDP galerisi: dikey sayfa kaydırmasını xo-carousel'in yatay sürükleme kilidinden korur.
   Vendor (xo-critical.min.js, panGesture) ilk touchmove'da |dx| * 3 > |dy| ise hareketi yatay sayıp
   preventDefault ediyor; dikeyden ~18°'den fazla sapan her kaydırma galeri tarafından yutuluyordu.
   Vendor dinleyicisi `document` üzerinde ve bubble aşamasında (touchstart'ta eklenir). Buradaki dinleyici
   `body` üzerinde olduğu için ondan önce çalışır; dikey ağırlıklı hareketi stopPropagation ile vendor'a
   hiç ulaştırmaz, böylece tarayıcı sayfayı kaydırır. Yatay hareketlere, dokunmalara ve çoklu dokunuşa karışmaz. */
(() => {
  if (window.HpPdpGalleryTouch) return;
  window.HpPdpGalleryTouch = true;

  const GALLERY = '.xo-main-product .xo-product-info-media-mobile';
  // Yön, parmak en az bu kadar (px, |dx| + |dy|) oynayınca belirlenir; iOS'ta ilk örnekler 1-2px ve gürültülüdür.
  const DEAD_ZONE = 4;
  let tracking = false;
  let vertical = null;
  let startX = 0;
  let startY = 0;
  let startScrollY = 0;

  // Capture: galeri içindeki hiçbir dinleyici bu kaydı engelleyemesin (yalnızca koordinat okunur).
  document.addEventListener(
    'touchstart',
    (event) => {
      const target = event.target;
      tracking =
        event.touches.length === 1 &&
        target instanceof Element &&
        Boolean(target.closest(GALLERY)) &&
        !target.closest('model-viewer');
      vertical = null;
      if (!tracking) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      startScrollY = window.scrollY;

      // Vendor panGesture vx/vy'yi yalnızca touchmove'da günceller. Dikey hareket vendor'dan gizlendiğinde
      // touchend önceki kaydırmanın hızını kullanıp 2. görselde pan durumunu 0'a sıfırlıyordu.
      const list = target.closest('xo-carousel-list');
      if (list && list.pan) {
        list.pan.vx = 0;
        list.pan.vy = 0;
      }
    },
    { passive: true, capture: true }
  );

  document.body.addEventListener(
    'touchmove',
    (event) => {
      if (!tracking) return;
      if (event.touches.length !== 1) {
        tracking = false;
        return;
      }

      if (vertical === null) {
        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        // Yön belli olana kadar vendor'a gösterme: ilk gördüğü örnekle yönü kilitliyor.
        if (dx + dy < DEAD_ZONE) {
          event.stopPropagation();
          return;
        }
        vertical = dy >= dx;
      }

      if (vertical) event.stopPropagation();
    },
    { passive: true }
  );

  // Vendor (CarouselItem.handleClick) küçük resimde touchend'i tıklama sayar. Hareket sayfayı kaydırdıysa
  // küçük resim seçilmesin. Capture: slaytın kendi touchend dinleyicisinden önce çalışır.
  document.addEventListener(
    'touchend',
    (event) => {
      if (!tracking || !vertical || window.scrollY === startScrollY) return;

      const target = event.target;
      const thumbList = target instanceof Element ? target.closest('xo-carousel-thumbnail xo-carousel-list') : null;
      if (!thumbList) return;

      thumbList.thumbClickBlocking = true;
      // Vendor aynı touchend'de bayrağı kendisi sıfırlar; bu yalnızca takılı kalmasın diye emniyet.
      setTimeout(() => {
        thumbList.thumbClickBlocking = false;
      }, 0);
    },
    { passive: true, capture: true }
  );
})();
